import { Brand, createBranded } from '@deltasierra/type-utilities';

export type EmailTemplateLayoutColumnId = Brand<string, 'EmailTemplateLayoutColumnId'>;
export const EmailTemplateLayoutColumnId = createBranded<EmailTemplateLayoutColumnId>();
